import { FeedbackStatus } from '@momentum/types';
import { Badge } from '@/shared/components/ui/Badge';
import { useTranslation } from 'react-i18next';

interface InteractionStatusBadgeProps {
  status: FeedbackStatus;
}

export const InteractionStatusBadge = ({
  status,
}: InteractionStatusBadgeProps) => {
  const { t } = useTranslation('interactions');

  const statusConfig = {
    [FeedbackStatus.DRAFT]: {
      label: t('draft'),
      className: 'bg-gray-50 text-gray-700 border-gray-200',
    },
    [FeedbackStatus.SENT]: {
      label: t('sent'),
      className: 'bg-blue-50 text-blue-700 border-blue-200',
    },
    [FeedbackStatus.ACTION_PLAN]: {
      label: t('actionPlan'),
      className: 'bg-yellow-50 text-yellow-700 border-yellow-200',
    },
    [FeedbackStatus.ACTION_PLAN_APPROVE]: {
      label: t('actionPlan'),
      className: 'bg-yellow-50 text-yellow-700 border-yellow-200',
    },
    [FeedbackStatus.FINISHED]: {
      label: t('finished'),
      className: 'bg-green-50 text-green-700 border-green-200',
    },
  };

  const config = statusConfig[status];
  if (!config) return null;

  return (
    <Badge variant="outline" className={config.className}>
      {config.label}
    </Badge>
  );
};
